import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus, Trash2, Save, Monitor, Gamepad2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";

export default function GamesTab() {
  const [items, setItems] = useState(null);
  const [ng, setNg] = useState({ name: "", platform: "pc", image_url: "" });

  const load = () => api.get("/admin/games").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!ng.name.trim()) return;
    try { await api.post("/admin/games", { ...ng, enabled: true, order: (items?.length || 0) + 1 }); setNg({ name: "", platform: "pc", image_url: "" }); toast.success("Game added"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const save = async (g) => {
    try { await api.put(`/admin/games/${g.id}`, { name: g.name, platform: g.platform, image_url: g.image_url, enabled: g.enabled, order: g.order }); toast.success("Game saved"); }
    catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => { try { await api.delete(`/admin/games/${id}`); toast.success("Game removed"); load(); } catch (e) { toast.error(apiError(e)); } };
  const update = (id, patch) => setItems((prev) => prev.map((g) => g.id === id ? { ...g, ...patch } : g));

  if (!items) return <Loader2 className="animate-spin text-purple-400" />;
  return (
    <div>
      <div className="glass rounded-2xl p-4 mb-5 flex flex-wrap gap-3 items-end">
        <div className="flex-1 min-w-[160px]">
          <label className="text-xs text-purple-400 font-mono uppercase">New Game</label>
          <Input data-testid="new-game-name" value={ng.name} onChange={(e) => setNg({ ...ng, name: e.target.value })} placeholder="e.g. GTA VI" className="mt-1 h-11 bg-purple-950/30 border-purple-500/30" />
        </div>
        <div className="flex-1 min-w-[160px]">
          <label className="text-xs text-purple-400 font-mono uppercase">Cover Image URL (optional)</label>
          <Input value={ng.image_url} onChange={(e) => setNg({ ...ng, image_url: e.target.value })} placeholder="https://..." className="mt-1 h-11 bg-purple-950/30 border-purple-500/30" />
        </div>
        <select value={ng.platform} onChange={(e) => setNg({ ...ng, platform: e.target.value })} data-testid="new-game-platform" className="h-11 rounded-xl bg-purple-950/40 border border-purple-500/30 px-3 text-sm">
          <option value="pc">PC</option><option value="ps5">PS5</option>
        </select>
        <Button data-testid="add-game-btn" onClick={add} className="h-11 bg-purple-600 hover:bg-purple-500"><Plus size={16} /> Add</Button>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((g) => (
          <div key={g.id} className="glass rounded-2xl p-4" data-testid={`admin-game-${g.id}`}>
            <div className="flex items-center gap-2 mb-2">
              {g.platform === "pc" ? <Monitor className="text-purple-300" size={16} /> : <Gamepad2 className="text-purple-300" size={16} />}
              <span className="text-[10px] font-mono uppercase text-purple-300">{g.platform}</span>
            </div>
            <Input value={g.name} onChange={(e) => update(g.id, { name: e.target.value })} className="h-10 bg-purple-950/30 border-purple-500/30 font-semibold mb-2" />
            <Input value={g.image_url} onChange={(e) => update(g.id, { image_url: e.target.value })} placeholder="Cover image URL" className="h-9 bg-purple-950/30 border-purple-500/30 text-xs mb-2" />
            <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 text-xs text-slate-400"><input type="checkbox" checked={g.enabled} onChange={(e) => update(g.id, { enabled: e.target.checked })} /> Enabled</label>
              <div className="flex gap-2">
                <Button size="sm" onClick={() => save(g)} data-testid={`save-game-${g.id}`} className="h-8 bg-emerald-600 hover:bg-emerald-500"><Save size={13} /></Button>
                <Button size="sm" variant="outline" onClick={() => del(g.id)} className="h-8 border-red-500/30 bg-transparent text-red-300"><Trash2 size={13} /></Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
